import { createSelector } from 'reselect';

import { getSiteUrl, getCompId } from 'shared/selectors/app-settings';
import parseQueryParams from 'shared/utils/get-query-params';

import { URL_PARAM_COMP_ID, URL_PARAM_VIDEO_ID } from 'wix-vod-shared/src/common/constants/url';

const getQueryParams = createSelector([getSiteUrl], parseQueryParams);

export const getVideoIdFromUrl = createSelector(
  [getQueryParams, getCompId],
  (queryParams, compId) => {

    if (!compId || compId !== queryParams[URL_PARAM_COMP_ID]) {
      return null;
    }

    return queryParams[URL_PARAM_VIDEO_ID];
  });

export const getUrlParam = createSelector(
  [
    getQueryParams,
    getCompId,
    (state, key) => key,
  ],
  (queryParams, compId, key) => {

    if (!compId || compId !== queryParams[URL_PARAM_COMP_ID]) {
      return null;
    }

    return queryParams[key];
  });



// WEBPACK FOOTER //
// ./src/widget/selectors/query-params.js